import { RecommendLinks } from 'components/RecommendLinks';
import { useRecommendLinks } from '../hooks/useRecommendLinks';

export const RecommendLink = () => {
  const data = useRecommendLinks();

  if (!data) return null;

  return <RecommendLinks data={[data]} />;
};
